//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod

const PostRemoveCacheKey = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.RemoveCacheKey,
        method: RequestType.POST,
        data,
    });

const ClearCacheKey = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ClearCacheKey,
        method: RequestType.POST,
        data,
    });

const PostTeam = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostTeam,
        method: RequestType.POST,
        data,
    });
const PostCreateCash = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostCreateCash,
        method: RequestType.POST,
        data,
    });
const PutCreateCash = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCreateCash,
        method: RequestType.PUT,
        data,
    });

const PostRemoveCacheTeam = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.RemoveCacheTeam + '/' + data,
        method: RequestType.DELETE,
    });
const DeleteMobilPanelConfigurationCache = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteMobilPanelConfigurationCache,
        method: RequestType.POST,
        data,
    });

const DeleteRedisKey = (databaseNumber: number, key: string): Promise<any> =>
    request({
        url: `${ApiURL.Command.DeleteRedisKey}/${databaseNumber}/${encodeURIComponent(key)}`,
        method: RequestType.DELETE,
    });

const BulkDeleteRedisKeys = (databaseNumber: number, keys: string[]): Promise<any> =>
    request({
        url: ApiURL.Command.BulkDeleteRedisKeys,
        method: RequestType.POST,
        data: {
            databaseNumber,
            keys,
        },
    });

const CacheCommand = {
  PostRemoveCacheKey,
  ClearCacheKey,
  PostRemoveCacheTeam,
  PostTeam,
  PostCreateCash,
  PutCreateCash,
  DeleteMobilPanelConfigurationCache,
  DeleteRedisKey,
  BulkDeleteRedisKeys
}

export default CacheCommand;
